import { aboutService } from '../Model/Services/aboutService.js';
import { serviceService } from '../Model/Services/serviceService.js';
import { faqService } from '../Model/Services/faqService.js';
import { ctaService } from '../Model/Services/ctaService.js';

export const warmupInitialData = () => {
  serviceService.warmup();
  aboutService.warmup();
  faqService.warmup();
  ctaService.get().catch(() => {});
};
